import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SvgIconComponent } from '@ngneat/svg-icon';

export enum PerioSameDayExamConfirmationEnum {
  Cancel,
  Edit,
}

export interface PerioSameDayExamConfirmationData {
  sameDayInProgress: boolean;
}

@Component({
  selector: 'lib-perio-same-day-exam-confirmation-modal',
  imports: [TranslatePipe, SvgIconComponent],
  templateUrl: './perio-same-day-exam-confirmation-modal.component.html',
  styleUrl: './perio-same-day-exam-confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioSameDayExamConfirmationModalComponent {
  private readonly dialogRef = inject(DialogRef<PerioSameDayExamConfirmationEnum>);
  private readonly dialogData = inject<PerioSameDayExamConfirmationData>(DIALOG_DATA);
  protected readonly sameDayInProgress = this.dialogData.sameDayInProgress;

  protected onCancelClick(): void {
    this.dialogRef.close(PerioSameDayExamConfirmationEnum.Cancel);
  }

  protected onEditClick(): void {
    this.dialogRef.close(PerioSameDayExamConfirmationEnum.Edit);
  }
}
